import * as React from "react";
import { UitkScrim } from "uitk-react-scrim";
import { useLocalization } from "@shared-ui/localization-context";
import { TripCardContentProps } from "../typings";
import { TripImage } from "./TripImage";

export const TripCardContent = (props: TripCardContentProps) => {
  const { formatDateString } = useLocalization();

  const tripDates = `${formatDateString(new Date(props.tripStartDate), {
    skeleton: "MMMEd",
  })} - ${formatDateString(new Date(props.tripEndDate), {
    skeleton: "MMMEd",
  })}`;

  return (
    <>
      <TripImage destinationName={props.destinationName} imageData={props.imageData} />
      <UitkScrim>
        <div className="uitk-grid">
          <div className="uitk-cell">
            <h1 className="uitk-type-500">{props.tripTitle}</h1>
          </div>
          <div className="uitk-cell">
            <div className="uitk-type-regular uitk-type-300">{tripDates}</div>
          </div>
        </div>
      </UitkScrim>
    </>
  );
};
